var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5V2.5C17.523 2.5 22 6.977 22 12.5H12Z",
    fill: "#FFD4C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5L17 21.16C18.5195 20.2816 19.7813 19.0191 20.6589 17.4991C21.5364 15.9791 21.9989 14.2551 22 12.5H12Z",
    fill: "#FFAA94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 21.16L11.9999 12.5V2.5C6.47693 2.502 2.00093 6.98 2.00293 12.503C2.00493 18.026 6.48293 22.502 12.0069 22.5C13.7598 22.4993 15.4816 22.0379 16.9999 21.162L17.0029 21.157L16.9989 21.16H16.9999Z",
    fill: "#FA896B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPie);
export default __webpack_public_path__ + "static/media/icon-pie.79da2c46629c4d606e27aca99f27486a.svg";
export { ForwardRef as ReactComponent };